import { TimeSlot } from './types'

export const DAYS_OF_WEEK = [
  { id: 'monday', label: 'Monday' },
  { id: 'tuesday', label: 'Tuesday' },
  { id: 'wednesday', label: 'Wednesday' },
  { id: 'thursday', label: 'Thursday' },
  { id: 'friday', label: 'Friday' },
  { id: 'saturday', label: 'Saturday' },
  { id: 'sunday', label: 'Sunday' },
] as const

// DEFAULT_TIME_SLOT is for a single slot; each day now uses an array of TimeSlot
export const DEFAULT_TIME_SLOT: Omit<TimeSlot, 'id'> = {
  startTime: '9:00',
  startPeriod: 'AM',
  endTime: '5:00',
  endPeriod: 'PM',
  allDay: false,
}

export const PERIOD_OPTIONS = ['AM', 'PM'] as const

// Time validation constants
export const TIME_REGEX = /^(0?[1-9]|1[0-2]):[0-5][0-9]$/
export const MINUTES_IN_DAY = 24 * 60
